import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Button, Card } from "@themesberg/react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { Routes } from "../routes";

/**
 * Catch-all for routes with no page behind them. Without it react-router logs
 * "No routes matched location" and the body renders empty (a blank white page).
 */
const RouteNotFound = () => {
  const { pathname } = useLocation();

  return (
    <Card border="light" className="shadow-sm text-center p-4 my-4">
      <h4 className="mb-2">Page not found</h4>
      <p className="text-gray mb-1">
        Nothing is routed to{" "}
        <code style={{ wordBreak: "break-word" }}>{pathname}</code>.
      </p>
      <p className="text-gray mb-4">
        The link may be out of date, or your account may not have access to this
        page.
      </p>
      <div className="d-flex flex-wrap justify-content-center gap-2">
        <Button as={Link} variant="primary" to={Routes.DashboardOverview.path}>
          <FontAwesomeIcon icon={faChevronLeft} className="me-2" />
          Go to dashboard
        </Button>
        <Button as={Link} variant="outline-secondary" to={Routes.Signin.path}>
          Sign in again
        </Button>
      </div>
    </Card>
  );
};

export default RouteNotFound;
